import React from 'react';
import './Grain.css';

export default function Grain() {
  return <div className="grain" aria-hidden="true" />;
}
